module.exports = __webpack_public_path__ + "img/Chart-Bar-Stack-Horizontal-Color.a5304d3c.png";